<template>
  <el-card v-loading="loading">
    <div class="title">库存数量</div>
    <div class="count">{{ statisticsData.totalInventoryQuantity }}</div>
    <div class="flex" style="margin-top: 30px">
      <span>
        <!-- 周环比：<CaretTop
          v-if="statisticsData.inventoryWeekRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{ statisticsData.inventoryWeekRate * 100 }}% -->
      </span>
      <span>
        <!-- 日环比：<CaretTop
          v-if="statisticsData.inventoryDayRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{ statisticsData.inventoryDayRate * 100 }}% -->
      </span>
    </div>
    <el-divider />
    <span>今日增减库存:{{ statisticsData.cdInventoryQuantity }}</span>
  </el-card>
  <el-card v-loading="loading">
    <div class="title">出库数量</div>
    <div class="count">{{ statisticsData.totalOutBoundQuantity }}</div>
    <div class="flex">
      <span
        >周环比：<CaretTop
          v-if="statisticsData.outBoundWeekRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.outBoundWeekRate
            ? (statisticsData.outBoundWeekRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
      <span
        >日环比：<CaretTop
          v-if="statisticsData.outBoundDayRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.outBoundDayRate
            ? (statisticsData.outBoundDayRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
    </div>
    <el-divider />
    <span>今日出库数量:{{ statisticsData.cdOutBoundQuantity }}</span>
  </el-card>
  <el-card v-loading="loading">
    <div class="title">入库数量</div>
    <div class="count">{{ statisticsData.totalInBoundQuantity }}</div>
    <div class="flex">
      <span
        >周环比：<CaretTop
          v-if="statisticsData.inBoundWeekRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.inBoundWeekRate
            ? (statisticsData.inBoundWeekRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
      <span
        >日环比：<CaretTop
          v-if="statisticsData.inBoundDayRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.inBoundDayRate
            ? (statisticsData.inBoundDayRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
    </div>
    <el-divider />
    <span>今日入库数量:{{ statisticsData.cdInBoundQuantity }}</span>
  </el-card>
  <el-card v-loading="loading">
    <div class="title">调拨数量</div>
    <div class="count">{{ statisticsData.totalAllocateQuantity }}</div>
    <div class="flex">
      <span
        >周环比：<CaretTop
          v-if="statisticsData.allocateWeekRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.allocateWeekRate
            ? (statisticsData.allocateWeekRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
      <span
        >日环比：<CaretTop
          v-if="statisticsData.allocateDayRate >= 0"
          style="width: 1em; height: 1em"
          color="#67C23A"
        /><CaretBottom v-else style="width: 1em; height: 1em" color="#F56C6C" />
        {{
          statisticsData.allocateDayRate
            ? (statisticsData.allocateDayRate * 100).toFixed(2)
            : "0"
        }}%</span
      >
    </div>
    <el-divider />
    <span>今日调拨数量:{{ statisticsData.cdAllocateQuantity }}</span>
  </el-card>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { queryInventoryBlock } from "@/api/statistics";

const loading = ref(false);

const statisticsData = ref({
  // allocateDayRate: 0,
  // allocateWeekRate: 0,
  // cdAllocateQuantity: 0,
  // cdInBoundQuantity: 0,
  // cdInventoryQuantity: 0,
  // cdOutBoundQuantity: 0,
  // inBoundDayRate: 0,
  // inBoundWeekRate: 0,
  // inventoryDayRate: 0,
  // inventoryWeekRate: 0,
  // outBoundDayRate: 0,
  // outBoundWeekRate: 0,
  // totalAllocateQuantity: 0,
  // totalInBoundQuantity: 0,
  // totalInventoryQuantity: 0,
  // totalOutBoundQuantity: 0,
  // yallocateQuantity: 0,
  // yinBoundQuantity: 0,
  // yinventoryQuantity: 0,
  // youtBoundQuantity: 0,
});

const title = reactive(["库存数量", "出库数量", "入库数量", "调拨数量"]);

onMounted(() => {
  queryInventoryBlock().then((res) => {
    statisticsData.value = res.data;
  });
});
</script>

<style scoped>
.title {
  color: #999999;
}
.count {
  height: 40px;
  line-height: 40px;
  font-size: 26px;
}

.flex {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
</style>
